import { BaseRequest } from '@/network/requests/BaseRequest'
import { job_order } from '@/interfaces/job_order'

export const jobOrderRequest = BaseRequest.build<job_order>('job_order')

/**
 * 获取工单表中所有的工人Id集合。
 */
export function getWorkers() {
	return jobOrderRequest.queryAllAndGroup('worker_id', undefined, { worker_id: 1 }, 1000)
}

/**
// 使用示例：

// 列表
jobOrderRequest.searchPage(10, 1)

// 列表，按机台id模糊搜索
jobOrderRequest.searchPage(10, 1, {jt_id: 'abc'})

// 列表，按工单号模糊搜索
jobOrderRequest.searchPage(10, 1, {work_order_code: 'abc'})

// 列表，按状态进行筛选。也可以按其他 job_order 中的字段进行筛选，此处仅给出按 status 筛选示例。
jobOrderRequest.searchPage(10, 1, {}, {status: [0, 1, 2]})

// 列表，按机台id模糊搜索，同时按状态进行筛选
jobOrderRequest.searchPage(10, 1, {jt_id: 'abc'}, {status: [0, 1, 2]})

// 列表，按状态进行筛选，并按 start_time 进行倒序排序
jobOrderRequest.searchPage(10, 1, {}, {status: [0, 1, 2]}, {start_time: -1})

// 在上面的基础上，指定返回结果中包含的字段
jobOrderRequest.searchPage(10, 1, {}, {status: [0, 1, 2]}, {start_time: -1}, {	end_time: 1, plates: 1,	roll_num: 1,	status: 1,	total_len: 1 })

// 在上面的基础上，指定返回结果中要排除的字段
jobOrderRequest.searchPage(10, 1, {}, {status: [0, 1, 2]}, {start_time: -1}, {	end_time: 0, plates: 0,	roll_num: 0,	status: 0,	total_len: 0 })


// 录入工单

jobOrderRequest.upload({
	 "work_order_code": "f2a95df44f6947f498609277292880d5", // 工单编号
	 "code": "1ffb86497399444cb8da538b0ac29206", //	派工单编号
	 "jt_id": "098b22ffd745427da1bdcde361fe3651", // 生产机台
	 "product_id": "2bd20ec0b90b4cab88571d5e25229247", // 产品
	 "worker_id": "2eaa8dddb9d84e4a858d993f71bbafab", // 工人
	 "start_time": {
		 "$date": 1590675696439
	 },
	 "end_time": {
		 "$date": 1590675696439
	 },
	 "plates": 81,
	 "pre_time": 6,
	 "status": 4,
	 "total_len": 76,
	 "roll_len": 24,
	 "roll_num": 6,
	 "process_group_id": "08d2f60637c645ceb636e8e753a4d615"
});

// 导入工单(上传多个工单对象)

jobOrderRequest.uploadBatch([{
	"work_order_code": "f2a95df44f6947f498609277292880d5", // 工单编号
	"code": "1ffb86497399444cb8da538b0ac29206", //	派工单编号
	"jt_id": "098b22ffd745427da1bdcde361fe3651", // 生产机台
	"product_id": "2bd20ec0b90b4cab88571d5e25229247", // 产品
	"worker_id": "2eaa8dddb9d84e4a858d993f71bbafab", // 工人
	"start_time": {
		"$date": 1590675696439
	},
	"end_time": {
		"$date": 1590675696439
	},
	"plates": 81,
	"pre_time": 6,
	"status": 4,
	"total_len": 76,
	"roll_len": 24,
	"roll_num": 6,
	"process_group_id": "08d2f60637c645ceb636e8e753a4d615"
}, ]);


*/
